import { MatDialog } from '@angular/material/dialog';
import { Injectable, TemplateRef, ElementRef } from '@angular/core';
import { IDetailsPopupParams } from './details-popup.interfaces';
import { DetailsPopupComponent } from './details-popup.component';

const POPUP_TITLE = 'Details';
const POPUP_WIDTH = '400px';

@Injectable()
export class DetailsPopupService {
  constructor(private readonly dialog: MatDialog) {}

  showPopup(params: IDetailsPopupParams) {
    this.dialog
      .open(DetailsPopupComponent, {
        hasBackdrop: true,
        data: {
          title: params.title || POPUP_TITLE,
          template: params.template,
          anchorElement: new ElementRef(params.anchorElement),
          anchorOrigin: params.anchorOrigin || {
            vertical: 'bottom',
            horizontal: 'right'
          },
          transformOrigin: params.transformOrigin || {
            vertical: 'top',
            horizontal: 'right'
          },
          size: params.size || { width: POPUP_WIDTH }
        }
      })
      .afterClosed()
      .subscribe(() => {
        if (params && params.fnCloseCallback) {
          params.fnCloseCallback();
        }
      });
  }

  closeAll() {
    this.dialog.closeAll();
  }
}
